module.exports = __webpack_public_path__ + "media/images/order-d876d9749745add3cf733f940b58121d.svg";